import React, { useEffect, useState } from 'react'
import { useTokensList } from './hooks'
import { ColumnsType } from 'antd/lib/table'
import { CCardBody, CSpinner } from '@coreui/react-pro'
import { Table } from 'antd'
import {
  $ordersByPropertyList,
  getOrdersByPropertyList,
  ordersByPropertyListMounted,
} from './model'
import { useUnit } from 'effector-react'

export const TokensList: React.FC = () => {
  const { tokensList, totalCountOfTokensList, onChangeTokensList, loading } =
    useTokensList()

  const ordersByPropertyList = useUnit($ordersByPropertyList)
  const isOrdersByPropertyLoading = useUnit(getOrdersByPropertyList.pending)

  const [orderBy, setOrderBy] = useState('id')
  const [orderDirection, setOrderDirection] = useState('-')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([])

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
  }

  useEffect(() => {
    onChangeTokensList({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
    })
  }, [pageSize, page, orderBy, orderDirection])

  const columns: ColumnsType<any> = [
    {
      title: 'Property ID',
      dataIndex: 'propertyId',
      sorter: (a, b) => a.propertyId - b.propertyId,
      defaultSortOrder: 'descend',
    },
    {
      title: 'Tokens',
      dataIndex: 'tokenAmount',
    },
    {
      title: 'Amount USD',
      dataIndex: 'amountUsd',
    },
    {
      title: 'Ends',
      dataIndex: 'ends',
    },
    {
      title: 'Token Storage',
      dataIndex: 'walletBalances',
      render: (walletBalances) => {
        return (
          <div>
            {walletBalances.length > 0 && (
              <>
                {walletBalances.map(
                  (item: { balance: number; address: string }) => (
                    <>
                      <div>
                        {`${
                          item.balance === 1
                            ? `${item.balance} token`
                            : `${item.balance} tokens`
                        }`}
                        :
                      </div>
                      <div>{item.address}</div>
                    </>
                  ),
                )}
              </>
            )}
          </div>
        )
      },
    },
    {
      title: 'Dividends Paid USD',
      dataIndex: 'dividendsPaidUsd',
    },
    {
      title: 'Dividends Planned USD',
      dataIndex: 'dividendsPlannedUsd',
    },
  ]

  const expandedColumns: ColumnsType<any> = [
    {
      title: 'Date and Time',
      dataIndex: 'date',
    },
    {
      title: 'Tokens',
      dataIndex: 'tokens',
    },
    {
      title: 'Order ID',
      dataIndex: 'orderId',
    },
    {
      title: 'Order type',
      dataIndex: 'orderType',
    },
    {
      title: 'Amount USD',
      dataIndex: 'amountUsd',
    },
  ]

  const expandedRowRender = () => {
    if (isOrdersByPropertyLoading) {
      return <CSpinner />
    }
    return (
      <Table
        columns={expandedColumns}
        dataSource={ordersByPropertyList}
        pagination={false}
      />
    )
  }

  return (
    <CCardBody>
      <Table
        dataSource={tokensList}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        columns={columns}
        pagination={false}
        onChange={(pagination, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
        expandable={{
          expandedRowRender,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            if (expanded) {
              setExpandedRowKeys([record.key])
              ordersByPropertyListMounted({ propertyId: record.propertyId })
            } else {
              setExpandedRowKeys([])
            }
          },
        }}
      />
    </CCardBody>
  )
}
